// extracted by mini-css-extract-plugin
export default {"collapabel_card_contianer":"styles_collapabel_card_contianer__B2--Y"};